import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import Env from "../util/env"

const renderRoutes = (routes: any[]) =>
  routes ? (
    <Switch>
      {routes.map((route: any, i: number) => (
        <Route
          key={i}
          exact={route.exact}
          path={route.path}
          render={props =>
            Env.isLogin() || !route.requiredAuth ? (
              <route.component {...props} />
            ) : (
              <Redirect
                to={{
                  pathname: "/auth",
                  state: {
                    from: props.location,
                    referrer: window.location.href
                  }
                }}
              />
            )
          }
        />
      ))}
    </Switch>
  ) : null

export default renderRoutes
